<template>
  <div class="login Kanit">
    <v-layout row wrap style="height: 100vh;">
      <v-flex md7 lg7 xl7 style="background: white;    display: flex;justify-content: center;">
        <div style="color: #aa0800ff; text-align: center;padding: 2vw;border: #aa0800 5px solid; border-radius: 10px;" class="vertical-center" align-center>
          <span style="font-size: 40px;">AED THAILAND</span>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md5 lg5 xl5 style="background: #aa0800ff; color: white;">
        <div style="margin-top: 10vh;">
          <img :src="BASE_URL + 'static/logo aed/aed9.svg'" style="height: 200px;" />
          <p style="font-size: 20px;">เข้าสู่ระบบ</p>
          <div align-center>
            <v-form>
            <v-text-field
              solo
              rounded
              v-model="username"
              label="ชื่อผู้ใช้"
              single-line
              outline
              prepend-inner-icon="account_circle"
              class="text-field horizontal-center"
              @keyup.enter="login()"
              style="display: inline-flex;"
            ></v-text-field>
            <v-text-field
              solo
              rounded
              v-model="password"
              label="รหัสผ่าน"
              single-line
              outline
              prepend-inner-icon="lock"
              class="text-field horizontal-center"
              @keyup.enter="login()"
              style="display: inline-flex;"
              type="password"
            ></v-text-field>
            <div style="justify-content: center;display: flex;" v-if="wrong>=3">
              <!-- <vue-recaptcha sitekey="6LcAB-oUAAAAAOf2Y66eQoMLFjgVHyT0-3P_z48J" :loadRecaptchaScript="true" >
                <button>Click me</button>
                
              </vue-recaptcha> -->

             <!-- <form action="?" method="POST"> -->
  <!--     <div class="g-recaptcha" @callback="markRecaptchaAsVerified" data-sitekey="6LeeBuoUAAAAACiE0IW__SVufyAHqYOyazLlAaGa"></div> -->

      <vue-recaptcha @verify="markRecaptchaAsVerified"
            sitekey="6LdUBuoUAAAAAFSGPDr4rzyQMhuBdG5D4Y_Lw5fE" 
           >
            
        </vue-recaptcha>
      <br/>
      <br/>
      <!-- <input type="submit" value="Submit"> -->

      
    <!-- </form> -->
            </div>





            <div style="justify-content: center;display: flex;">
            
<v-btn rounded dark :disabled="!checkVerify && wrong>=3" style="background: white; color: #aa0800ff;"  @click="login()">ลงชื่อเข้าใช้</v-btn>
          </div>
        </v-form>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Encode, Decode } from '@/services'
import VueRecaptcha from 'vue-recaptcha';
export default {
  data () {
    return {
      msg: 'Login',
      username: '',
      password: '',
      BASE_URL: process.env.BASE_URL,
      authen: {},
      wrong: 0,
      checkVerify: false
    }
  },
  created () {
    // console.log(localStorage.getItem('key'))
    if (localStorage.getItem('key')) {
      var decode = Decode.decode(localStorage.getItem('key'))
      // console.log(decode)
      if (decode !== undefined && decode.length > 7) {
        this.$router.push('/homepage')
      } else {
        this.authen = JSON.parse(decode)
        if (this.authen.role === 'superadmin') {
          this.$router.push('/homepage')
        }
      }

    }
  },
  components: { VueRecaptcha },
  methods: {
    markRecaptchaAsVerified (value) {
      // console.log('markRecaptchaAsVerified')
      // console.log(value)
      if (value) {
        this.checkVerify = true
      }
    },
    login () {
      var body = {
        username: this.username,
        password: this.password
      }
      this.axios.post(process.env.API_BACKEND + '/v1/login_by_username', body, {headers: this.headerAPI}).then((response) => {
        if (response.data.message == "login_fail") {
          this.wrong = this.wrong + 1
          this.checkVerify = false
          if (this.wrong >=4) {
            grecaptcha.reset()
          }
          this.$swal('ลงชื่อเข้าใช้งาน ไม่สำเร็จ', 'กรุณาตรวจสอบชื่อผู้ใช้ และรหัสผ่านใหม่อีกครั้ง', 'error')

        } else if (response.data.message == "login_success") {
          var encode = Encode.encode({'Authorization': response.data.auth_token, 'role': response.data.data.role, 'typeCompany': response.data.data.company_data.company_type, 'nameCompany': response.data.data.company_data.company_name, 'idCompany': response.data.data.company_data.company_id, 'typeServer': process.env.NODE_ENV})
          localStorage.setItem('key', encode)
          if (response.data.data.role === 'superadmin') {
            this.$router.push('/homepage')
          } else {
            // alert no premission
            this.$swal('ลงชื่อเข้าใช้งาน ไม่สำเร็จ', 'คุณไม่มีสิทธิ์ในการลงชื่อเข้าใช้เว็บไซต์', 'error')
          }

        } else {
          // alert there is problem connect later
          this.$swal('ลงชื่อเข้าใช้งาน ไม่สำเร็จ', 'มีบางอย่างผิดปกติ กรุณาลองใหม่ในภายหลัง', 'error')
        }
      })
    }
  }
}
</script>
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
.text-field {
   width: 50%;
}
.text-field label{
  background: white !important;
}
.text-field .v-input__slot{
  background: white !important;
}
>>>.theme--light.v-icon {
  color: rgb(170, 8, 0);
}
>>>.text-field:focus .theme--light.v-icon {
  color: white;
}
>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
    border: 2px solid white;
    border-radius: 50px;
    background: white !important;
}
>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot:hover {
    border: 2px solid white;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue